/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthSettingsRouteImport } from './routes/_auth.settings'
import { Route as AuthInboxRouteImport } from './routes/_auth.inbox'
import { Route as AuthDashboardRouteImport } from './routes/_auth.dashboard'
import { Route as AuthInboxIndexRouteImport } from './routes/_auth.inbox.index'
import { Route as AuthDashboardIndexRouteImport } from './routes/_auth.dashboard.index'
import { Route as AuthTicketsTicketIdRouteImport } from './routes/_auth.tickets.$ticketId'
import { Route as AuthSettingsUsersRouteImport } from './routes/_auth.settings.users'
import { Route as AuthSettingsTagsRouteImport } from './routes/_auth.settings.tags'
import { Route as AuthSettingsSlaPoliciesRouteImport } from './routes/_auth.settings.sla-policies'
import { Route as AuthSettingsProfileRouteImport } from './routes/_auth.settings.profile'
import { Route as AuthSettingsOrganizationsRouteImport } from './routes/_auth.settings.organizations'
import { Route as AuthSettingsNotificationsRouteImport } from './routes/_auth.settings.notifications'
import { Route as AuthSettingsMailboxesRouteImport } from './routes/_auth.settings.mailboxes'
import { Route as AuthSettingsMailboxAccessRouteImport } from './routes/_auth.settings.mailbox-access'
import { Route as AuthSettingsGroupsRouteImport } from './routes/_auth.settings.groups'
import { Route as AuthSettingsDelegationsRouteImport } from './routes/_auth.settings.delegations'
import { Route as AuthSettingsAssignmentRulesRouteImport } from './routes/_auth.settings.assignment-rules'
import { Route as AuthInboxTicketIdRouteImport } from './routes/_auth.inbox.$ticketId'
import { Route as AuthSettingsMailboxesIndexRouteImport } from './routes/_auth.settings.mailboxes.index'
import { Route as AuthSettingsMailboxesMailboxIdRouteImport } from './routes/_auth.settings.mailboxes.$mailboxId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSettingsRoute = AuthSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInboxRoute = AuthInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDashboardRoute = AuthDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInboxIndexRoute = AuthInboxIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthInboxRoute,
} as any)
const AuthDashboardIndexRoute = AuthDashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthDashboardRoute,
} as any)
const AuthTicketsTicketIdRoute = AuthTicketsTicketIdRouteImport.update({
  id: '/tickets/$ticketId',
  path: '/tickets/$ticketId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsUsersRoute = AuthSettingsUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsTagsRoute = AuthSettingsTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsSlaPoliciesRoute = AuthSettingsSlaPoliciesRouteImport.update({
  id: '/sla-policies',
  path: '/sla-policies',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsProfileRoute = AuthSettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsOrganizationsRoute =
  AuthSettingsOrganizationsRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => AuthSettingsRoute,
  } as any)
const AuthSettingsNotificationsRoute =
  AuthSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthSettingsRoute,
  } as any)
const AuthSettingsMailboxesRoute = AuthSettingsMailboxesRouteImport.update({
  id: '/mailboxes',
  path: '/mailboxes',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsMailboxAccessRoute =
  AuthSettingsMailboxAccessRouteImport.update({
    id: '/mailbox-access',
    path: '/mailbox-access',
    getParentRoute: () => AuthSettingsRoute,
  } as any)
const AuthSettingsGroupsRoute = AuthSettingsGroupsRouteImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsDelegationsRoute = AuthSettingsDelegationsRouteImport.update({
  id: '/delegations',
  path: '/delegations',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsAssignmentRulesRoute =
  AuthSettingsAssignmentRulesRouteImport.update({
    id: '/assignment-rules',
    path: '/assignment-rules',
    getParentRoute: () => AuthSettingsRoute,
  } as any)
const AuthInboxTicketIdRoute = AuthInboxTicketIdRouteImport.update({
  id: '/$ticketId',
  path: '/$ticketId',
  getParentRoute: () => AuthInboxRoute,
} as any)
const AuthSettingsMailboxesIndexRoute =
  AuthSettingsMailboxesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthSettingsMailboxesRoute,
  } as any)
const AuthSettingsMailboxesMailboxIdRoute =
  AuthSettingsMailboxesMailboxIdRouteImport.update({
    id: '/$mailboxId',
    path: '/$mailboxId',
    getParentRoute: () => AuthSettingsMailboxesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dashboard': typeof AuthDashboardRouteWithChildren
  '/inbox': typeof AuthInboxRouteWithChildren
  '/settings': typeof AuthSettingsRouteWithChildren
  '/inbox/$ticketId': typeof AuthInboxTicketIdRoute
  '/settings/assignment-rules': typeof AuthSettingsAssignmentRulesRoute
  '/settings/delegations': typeof AuthSettingsDelegationsRoute
  '/settings/groups': typeof AuthSettingsGroupsRoute
  '/settings/mailbox-access': typeof AuthSettingsMailboxAccessRoute
  '/settings/mailboxes': typeof AuthSettingsMailboxesRouteWithChildren
  '/settings/notifications': typeof AuthSettingsNotificationsRoute
  '/settings/organizations': typeof AuthSettingsOrganizationsRoute
  '/settings/profile': typeof AuthSettingsProfileRoute
  '/settings/sla-policies': typeof AuthSettingsSlaPoliciesRoute
  '/settings/tags': typeof AuthSettingsTagsRoute
  '/settings/users': typeof AuthSettingsUsersRoute
  '/tickets/$ticketId': typeof AuthTicketsTicketIdRoute
  '/dashboard/': typeof AuthDashboardIndexRoute
  '/inbox/': typeof AuthInboxIndexRoute
  '/settings/mailboxes/$mailboxId': typeof AuthSettingsMailboxesMailboxIdRoute
  '/settings/mailboxes/': typeof AuthSettingsMailboxesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/settings': typeof AuthSettingsRouteWithChildren
  '/inbox/$ticketId': typeof AuthInboxTicketIdRoute
  '/settings/assignment-rules': typeof AuthSettingsAssignmentRulesRoute
  '/settings/delegations': typeof AuthSettingsDelegationsRoute
  '/settings/groups': typeof AuthSettingsGroupsRoute
  '/settings/mailbox-access': typeof AuthSettingsMailboxAccessRoute
  '/settings/notifications': typeof AuthSettingsNotificationsRoute
  '/settings/organizations': typeof AuthSettingsOrganizationsRoute
  '/settings/profile': typeof AuthSettingsProfileRoute
  '/settings/sla-policies': typeof AuthSettingsSlaPoliciesRoute
  '/settings/tags': typeof AuthSettingsTagsRoute
  '/settings/users': typeof AuthSettingsUsersRoute
  '/tickets/$ticketId': typeof AuthTicketsTicketIdRoute
  '/dashboard': typeof AuthDashboardIndexRoute
  '/inbox': typeof AuthInboxIndexRoute
  '/settings/mailboxes/$mailboxId': typeof AuthSettingsMailboxesMailboxIdRoute
  '/settings/mailboxes': typeof AuthSettingsMailboxesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth/dashboard': typeof AuthDashboardRouteWithChildren
  '/_auth/inbox': typeof AuthInboxRouteWithChildren
  '/_auth/settings': typeof AuthSettingsRouteWithChildren
  '/_auth/inbox/$ticketId': typeof AuthInboxTicketIdRoute
  '/_auth/settings/assignment-rules': typeof AuthSettingsAssignmentRulesRoute
  '/_auth/settings/delegations': typeof AuthSettingsDelegationsRoute
  '/_auth/settings/groups': typeof AuthSettingsGroupsRoute
  '/_auth/settings/mailbox-access': typeof AuthSettingsMailboxAccessRoute
  '/_auth/settings/mailboxes': typeof AuthSettingsMailboxesRouteWithChildren
  '/_auth/settings/notifications': typeof AuthSettingsNotificationsRoute
  '/_auth/settings/organizations': typeof AuthSettingsOrganizationsRoute
  '/_auth/settings/profile': typeof AuthSettingsProfileRoute
  '/_auth/settings/sla-policies': typeof AuthSettingsSlaPoliciesRoute
  '/_auth/settings/tags': typeof AuthSettingsTagsRoute
  '/_auth/settings/users': typeof AuthSettingsUsersRoute
  '/_auth/tickets/$ticketId': typeof AuthTicketsTicketIdRoute
  '/_auth/dashboard/': typeof AuthDashboardIndexRoute
  '/_auth/inbox/': typeof AuthInboxIndexRoute
  '/_auth/settings/mailboxes/$mailboxId': typeof AuthSettingsMailboxesMailboxIdRoute
  '/_auth/settings/mailboxes/': typeof AuthSettingsMailboxesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/dashboard'
    | '/inbox'
    | '/settings'
    | '/inbox/$ticketId'
    | '/settings/assignment-rules'
    | '/settings/delegations'
    | '/settings/groups'
    | '/settings/mailbox-access'
    | '/settings/mailboxes'
    | '/settings/notifications'
    | '/settings/organizations'
    | '/settings/profile'
    | '/settings/sla-policies'
    | '/settings/tags'
    | '/settings/users'
    | '/tickets/$ticketId'
    | '/dashboard/'
    | '/inbox/'
    | '/settings/mailboxes/$mailboxId'
    | '/settings/mailboxes/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/settings'
    | '/inbox/$ticketId'
    | '/settings/assignment-rules'
    | '/settings/delegations'
    | '/settings/groups'
    | '/settings/mailbox-access'
    | '/settings/notifications'
    | '/settings/organizations'
    | '/settings/profile'
    | '/settings/sla-policies'
    | '/settings/tags'
    | '/settings/users'
    | '/tickets/$ticketId'
    | '/dashboard'
    | '/inbox'
    | '/settings/mailboxes/$mailboxId'
    | '/settings/mailboxes'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/login'
    | '/_auth/dashboard'
    | '/_auth/inbox'
    | '/_auth/settings'
    | '/_auth/inbox/$ticketId'
    | '/_auth/settings/assignment-rules'
    | '/_auth/settings/delegations'
    | '/_auth/settings/groups'
    | '/_auth/settings/mailbox-access'
    | '/_auth/settings/mailboxes'
    | '/_auth/settings/notifications'
    | '/_auth/settings/organizations'
    | '/_auth/settings/profile'
    | '/_auth/settings/sla-policies'
    | '/_auth/settings/tags'
    | '/_auth/settings/users'
    | '/_auth/tickets/$ticketId'
    | '/_auth/dashboard/'
    | '/_auth/inbox/'
    | '/_auth/settings/mailboxes/$mailboxId'
    | '/_auth/settings/mailboxes/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/settings': {
      id: '/_auth/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthSettingsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/inbox': {
      id: '/_auth/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AuthInboxRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboard': {
      id: '/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/inbox/': {
      id: '/_auth/inbox/'
      path: '/'
      fullPath: '/inbox/'
      preLoaderRoute: typeof AuthInboxIndexRouteImport
      parentRoute: typeof AuthInboxRoute
    }
    '/_auth/dashboard/': {
      id: '/_auth/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthDashboardIndexRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/tickets/$ticketId': {
      id: '/_auth/tickets/$ticketId'
      path: '/tickets/$ticketId'
      fullPath: '/tickets/$ticketId'
      preLoaderRoute: typeof AuthTicketsTicketIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/users': {
      id: '/_auth/settings/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AuthSettingsUsersRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/tags': {
      id: '/_auth/settings/tags'
      path: '/tags'
      fullPath: '/settings/tags'
      preLoaderRoute: typeof AuthSettingsTagsRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/sla-policies': {
      id: '/_auth/settings/sla-policies'
      path: '/sla-policies'
      fullPath: '/settings/sla-policies'
      preLoaderRoute: typeof AuthSettingsSlaPoliciesRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/profile': {
      id: '/_auth/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthSettingsProfileRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/organizations': {
      id: '/_auth/settings/organizations'
      path: '/organizations'
      fullPath: '/settings/organizations'
      preLoaderRoute: typeof AuthSettingsOrganizationsRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/notifications': {
      id: '/_auth/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthSettingsNotificationsRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/mailboxes': {
      id: '/_auth/settings/mailboxes'
      path: '/mailboxes'
      fullPath: '/settings/mailboxes'
      preLoaderRoute: typeof AuthSettingsMailboxesRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/mailbox-access': {
      id: '/_auth/settings/mailbox-access'
      path: '/mailbox-access'
      fullPath: '/settings/mailbox-access'
      preLoaderRoute: typeof AuthSettingsMailboxAccessRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/groups': {
      id: '/_auth/settings/groups'
      path: '/groups'
      fullPath: '/settings/groups'
      preLoaderRoute: typeof AuthSettingsGroupsRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/delegations': {
      id: '/_auth/settings/delegations'
      path: '/delegations'
      fullPath: '/settings/delegations'
      preLoaderRoute: typeof AuthSettingsDelegationsRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/assignment-rules': {
      id: '/_auth/settings/assignment-rules'
      path: '/assignment-rules'
      fullPath: '/settings/assignment-rules'
      preLoaderRoute: typeof AuthSettingsAssignmentRulesRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/inbox/$ticketId': {
      id: '/_auth/inbox/$ticketId'
      path: '/$ticketId'
      fullPath: '/inbox/$ticketId'
      preLoaderRoute: typeof AuthInboxTicketIdRouteImport
      parentRoute: typeof AuthInboxRoute
    }
    '/_auth/settings/mailboxes/': {
      id: '/_auth/settings/mailboxes/'
      path: '/'
      fullPath: '/settings/mailboxes/'
      preLoaderRoute: typeof AuthSettingsMailboxesIndexRouteImport
      parentRoute: typeof AuthSettingsMailboxesRoute
    }
    '/_auth/settings/mailboxes/$mailboxId': {
      id: '/_auth/settings/mailboxes/$mailboxId'
      path: '/$mailboxId'
      fullPath: '/settings/mailboxes/$mailboxId'
      preLoaderRoute: typeof AuthSettingsMailboxesMailboxIdRouteImport
      parentRoute: typeof AuthSettingsMailboxesRoute
    }
  }
}

interface AuthDashboardRouteChildren {
  AuthDashboardIndexRoute: typeof AuthDashboardIndexRoute
}

const AuthDashboardRouteChildren: AuthDashboardRouteChildren = {
  AuthDashboardIndexRoute: AuthDashboardIndexRoute,
}

const AuthDashboardRouteWithChildren = AuthDashboardRoute._addFileChildren(
  AuthDashboardRouteChildren,
)

interface AuthInboxRouteChildren {
  AuthInboxTicketIdRoute: typeof AuthInboxTicketIdRoute
  AuthInboxIndexRoute: typeof AuthInboxIndexRoute
}

const AuthInboxRouteChildren: AuthInboxRouteChildren = {
  AuthInboxTicketIdRoute: AuthInboxTicketIdRoute,
  AuthInboxIndexRoute: AuthInboxIndexRoute,
}

const AuthInboxRouteWithChildren = AuthInboxRoute._addFileChildren(
  AuthInboxRouteChildren,
)

interface AuthSettingsMailboxesRouteChildren {
  AuthSettingsMailboxesMailboxIdRoute: typeof AuthSettingsMailboxesMailboxIdRoute
  AuthSettingsMailboxesIndexRoute: typeof AuthSettingsMailboxesIndexRoute
}

const AuthSettingsMailboxesRouteChildren: AuthSettingsMailboxesRouteChildren = {
  AuthSettingsMailboxesMailboxIdRoute: AuthSettingsMailboxesMailboxIdRoute,
  AuthSettingsMailboxesIndexRoute: AuthSettingsMailboxesIndexRoute,
}

const AuthSettingsMailboxesRouteWithChildren =
  AuthSettingsMailboxesRoute._addFileChildren(
    AuthSettingsMailboxesRouteChildren,
  )

interface AuthSettingsRouteChildren {
  AuthSettingsAssignmentRulesRoute: typeof AuthSettingsAssignmentRulesRoute
  AuthSettingsDelegationsRoute: typeof AuthSettingsDelegationsRoute
  AuthSettingsGroupsRoute: typeof AuthSettingsGroupsRoute
  AuthSettingsMailboxAccessRoute: typeof AuthSettingsMailboxAccessRoute
  AuthSettingsMailboxesRoute: typeof AuthSettingsMailboxesRouteWithChildren
  AuthSettingsNotificationsRoute: typeof AuthSettingsNotificationsRoute
  AuthSettingsOrganizationsRoute: typeof AuthSettingsOrganizationsRoute
  AuthSettingsProfileRoute: typeof AuthSettingsProfileRoute
  AuthSettingsSlaPoliciesRoute: typeof AuthSettingsSlaPoliciesRoute
  AuthSettingsTagsRoute: typeof AuthSettingsTagsRoute
  AuthSettingsUsersRoute: typeof AuthSettingsUsersRoute
}

const AuthSettingsRouteChildren: AuthSettingsRouteChildren = {
  AuthSettingsAssignmentRulesRoute: AuthSettingsAssignmentRulesRoute,
  AuthSettingsDelegationsRoute: AuthSettingsDelegationsRoute,
  AuthSettingsGroupsRoute: AuthSettingsGroupsRoute,
  AuthSettingsMailboxAccessRoute: AuthSettingsMailboxAccessRoute,
  AuthSettingsMailboxesRoute: AuthSettingsMailboxesRouteWithChildren,
  AuthSettingsNotificationsRoute: AuthSettingsNotificationsRoute,
  AuthSettingsOrganizationsRoute: AuthSettingsOrganizationsRoute,
  AuthSettingsProfileRoute: AuthSettingsProfileRoute,
  AuthSettingsSlaPoliciesRoute: AuthSettingsSlaPoliciesRoute,
  AuthSettingsTagsRoute: AuthSettingsTagsRoute,
  AuthSettingsUsersRoute: AuthSettingsUsersRoute,
}

const AuthSettingsRouteWithChildren = AuthSettingsRoute._addFileChildren(
  AuthSettingsRouteChildren,
)

interface AuthRouteChildren {
  AuthDashboardRoute: typeof AuthDashboardRouteWithChildren
  AuthInboxRoute: typeof AuthInboxRouteWithChildren
  AuthSettingsRoute: typeof AuthSettingsRouteWithChildren
  AuthTicketsTicketIdRoute: typeof AuthTicketsTicketIdRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthDashboardRoute: AuthDashboardRouteWithChildren,
  AuthInboxRoute: AuthInboxRouteWithChildren,
  AuthSettingsRoute: AuthSettingsRouteWithChildren,
  AuthTicketsTicketIdRoute: AuthTicketsTicketIdRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
